export default "__VITE_ASSET__d5e41ceb__"